import React from 'react'
import "./FrontScreen.css"

function FrontScreen() {
    return (
        <div>
            FRONT
        </div>
    )
}

export default FrontScreen
